import React, { useEffect, useState } from 'react';
import api from '../../api';

const DownloadReport = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/public/events')
      .then(res => setEvents(res.data))
      .catch(() => setEvents([]));
  }, []);

  const handleDownload = async (format) => {
    if (!selectedEvent) return alert('Pilih event terlebih dahulu!');
    setLoading(true);
    try {
      const response = await api.get(`/report/peserta`, {
        params: { eventId: selectedEvent, format },
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `laporan_peserta.${format === 'excel' ? 'xlsx' : 'csv'}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      alert('Gagal download file');
    }
    setLoading(false);
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="card shadow" style={{ width: '100%', maxWidth: 500 }}>
        <div className="card-header bg-primary text-white fw-bold text-center">
          Download Laporan Peserta
        </div>
        <div className="card-body">
          <div className="mb-3">
            <label htmlFor="eventSelect" className="form-label">
              Pilih Event
            </label>
            <select
              id="eventSelect"
              className="form-select"
              value={selectedEvent}
              onChange={e => setSelectedEvent(e.target.value)}
            >
              <option value="">-- Pilih Event --</option>
              {events.map(ev => (
                <option key={ev.id} value={ev.id}>
                  {ev.eventCode} - {ev.title}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex justify-content-between">
            <button
              className="btn btn-success"
              disabled={!selectedEvent || loading}
              onClick={() => handleDownload('excel')}
            >
              {loading ? 'Mengunduh...' : 'Download Excel'}
            </button>
            <button
              className="btn btn-primary"
              disabled={!selectedEvent || loading}
              onClick={() => handleDownload('csv')}
            >
              {loading ? 'Mengunduh...' : 'Download CSV'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadReport;
